import { FAYTEX_LEADERSHIP } from "@/lib/leadership";

function initials(name) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
}

export default function ExecutiveTeam() {
  return (
    <section data-testid="executive-team" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
      <div className="text-center max-w-2xl mx-auto">
        <p className="text-xs uppercase tracking-widest text-faytex-pink font-semibold">The team behind the brand</p>
        <h2 className="font-heading text-4xl md:text-5xl mt-3 tracking-tight">Meet our executives.</h2>
        <p className="mt-4 text-faytex-muted">
          The Ghanaian leadership shaping Faytex today — and its next 45 years.
        </p>
      </div>

      <div data-testid="exec-grid" className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FAYTEX_LEADERSHIP.map((p) => (
          <article
            key={p.id}
            data-testid={`exec-card-${p.id}`}
            className="rounded-3xl bg-white border border-gray-100 shadow-soft hover:shadow-hover transition-shadow overflow-hidden flex flex-col"
          >
            <div className="aspect-[4/5] bg-faytex-pinkLight/40 flex items-center justify-center overflow-hidden">
              {p.image ? (
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top"
                />
              ) : (
                <span className="font-heading text-5xl md:text-6xl text-faytex-pink" aria-hidden="true">
                  {initials(p.name)}
                </span>
              )}
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <p className="text-[11px] uppercase tracking-widest text-faytex-pink font-semibold">{p.role}</p>
              <h3 className="font-heading text-2xl mt-1">{p.name}</h3>
              <p className="mt-3 text-sm text-faytex-muted leading-relaxed">{p.bio}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
